import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    DxButtonModule,
    DxDateBoxModule,
    DxFormModule,
    DxLoadPanelModule,
    DxRadioGroupModule,
    DxScrollViewModule,
    DxSelectBoxModule,
    DxTextAreaModule,
    DxTextBoxModule,
    DxToolbarModule,
    DxValidationGroupModule,
    DxValidatorModule,
} from 'devextreme-angular';
import { IncidentReportDto } from '@services';
import { DxCheckBoxModule } from 'devextreme-angular/ui/check-box';

@Component({
    selector: 'app-activity-section',
    imports: [
        CommonModule,
        DxToolbarModule,
        DxButtonModule,
        DxLoadPanelModule,
        DxValidationGroupModule,
        DxTextBoxModule,
        DxValidatorModule,
        DxSelectBoxModule,
        DxDateBoxModule,
        DxScrollViewModule,
        DxFormModule,
        DxRadioGroupModule,
        DxTextAreaModule,
        DxCheckBoxModule,
    ],
    templateUrl: './activity-section.component.html',
})
export class ActivitySectionComponent {
    @Input() incidentReport: IncidentReportDto;
    @Input() isReadOnly: boolean = false;
}
